module.exports={
    authServiceUrl:'https://dashboard.firehouse247.com/api/id/'
}